import { useMutation } from '@tanstack/react-query';
import { leaveConversation } from '../../services/chats';

interface Options {
  onSuccess?: (data: Awaited<ReturnType<typeof leaveConversation>>) => void;
  onError?: (error: Error) => void;
}

function useLeaveConversation({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: leaveConversation,
    onSuccess,
    onError,
  });
}

export default useLeaveConversation;
